import React from "react";
import "./Realestatemarketing.css";
import centerimage from "../../assets/شهادة-فال-1.png"; 
import logoimage from "../../assets/cropped-cropped-cropped-عقاري-1-1 (1).webp";

const Realestatemarketing = () => {
  return (
    <>
    
    <div className="heading-h1">
    <h1 className="title">Real Estate Marketing Service</h1>
    </div>
    
      <div className="logo-container">
      <img src={logoimage} alt="Akari Logo" className="logo" />
      </div>
      <div className="content">
      <h3>رقم الرخصة-1200016943</h3>
      <h2 className="section-title">تعريف الخدمة</h2>
        <p className="text">خدمة تسويق العقارات</p>
        <h2 className="section-title">مقدم الخدمة:</h2>
        <p className="text">مكتب عبدالله ناصر العتيق العقاري</p>
      <div className="image-container">
        <img src={centerimage} alt="Center Image" className="center-image" />
      </div>

      </div>

      
    
      
     
      
      </>
  );
};

export default Realestatemarketing;
